export default __webpack_public_path__ + "static/media/Honored Bracers of the Golden Horde.67699095.jpg";